import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { BackgroundVerificationService } from '../../../Model/BackgroundVerification/background-verification.service';

@Component({
  selector: 'app-background-verification-policy',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './background-verification-policy.component.html',
  styleUrl: './background-verification-policy.component.scss'
})
export class BackgroundVerificationPolicyComponent {
  isDisabled: boolean = false;
  RegularData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private backgroundVerification: BackgroundVerificationService,
    protected common: CommonService,
    private download: DownloadSampleService,
    private toast: ToastService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_bgvPolicyLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_bgvPolicyLoad() {
    this.isDisabled = true;
    this.backgroundVerification.ESS_bgvPolicyLoad({ SelectType: 1, ESS_bgvPolicyID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element: any) => {
          element.WebESSApplicability = response.Table2.filter((e: any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
